import Button from 'components/Button';
import React, { FC, Fragment, Dispatch, SetStateAction } from 'react';
import { PartModalButtonContainer } from '../SetModal.styles';
import { PartModalContentType } from './SelectPart';

interface SelectPartTrayProps {
  trays: string[];
  setNewPartTray: Dispatch<SetStateAction<string | undefined>>;
  setPartContent: Dispatch<SetStateAction<PartModalContentType>>;
}

// Workflow to select what tray the existing part will be added to
const SelectPartTray: FC<SelectPartTrayProps> = ({ trays, setNewPartTray, setPartContent }) => {
  // Selects the desired tray and moves to the search workflow
  const handleClick = (tray: string): void => {
    setNewPartTray(tray);
    setPartContent('search');
  };

  return (
    <Fragment>
      {trays.map(tray => (
        <PartModalButtonContainer key={tray}>
          <Button fullWidth onClick={() => handleClick(tray)}>
            {tray}
          </Button>
        </PartModalButtonContainer>
      ))}
    </Fragment>
  );
};
export default SelectPartTray;
